<template>
  <div class="comboDialog">
    <el-dialog title="组合筛选查找" width="82%" :visible.sync="visible">
      <rtas-choose v-show="type === '1'"></rtas-choose>
      <rtas-find v-show="type === '2'"></rtas-find>
    </el-dialog>
  </div>
</template>

<script>
  import bus from './bus'
  import rtasChoose from './comboChoose'
  import rtasFind from './comboFind'

    export default {
        name: "comboDialog",
        components:{
            rtasChoose,
            rtasFind
        },
        data(){
          return {
            /*控制开关*/
            visible:false,
            /*控制显示内容*/
            type:'1'
          }
        },
        methods:{

        },
        created(){
          /*打开弹窗*/
          bus.$on('filterFind',()=>{
            this.visible = true;
          });
          /*选择完毕之后*/
          bus.$on('chooseType',()=>{
            this.type = '2';
          });
          /*取消选择*/
          bus.$on('cancel',()=>{
            this.type = '1';
          });
          /*获取到数据后关闭弹出框*/
          bus.$on('getResult',()=>{
            this.visible = 'false';
          });
        }
    }
</script>

<style scoped>

</style>

<style>
  .comboDialog .el-dialog{
    min-width: 1200px !important;
    height: 70% !important;
  }
  .comboDialog .el-dialog__body{
    padding: 0 !important;
    height: calc(100% - 54px);
  }
</style>



// WEBPACK FOOTER //
// src/data/comboDialog.vue